import React from 'react';
import getAppointmentTypes from '../api/getAppointmentTypes';
import { AppointmentType } from '../types/AppointmentType';

const useAppointmentTypes = (): [AppointmentType[] | null, boolean] => {
  const [appointmentTypes, setAppointmentTypes] = React.useState<AppointmentType[] | null>(null);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    setIsLoading(true);
    const { cancel } = getAppointmentTypes()
      .then((res) => setAppointmentTypes(res.success ? res.payload : null))
      .catch(() => setAppointmentTypes(null))
      .finally(() => setIsLoading(false));
    return cancel;
  }, []);

  return [appointmentTypes, isLoading];
};

export default useAppointmentTypes;
